<template>
  <div>
    <v-row>
      <v-col sm="12">{{$t('fleet.vehicle')}}</v-col>
      <v-col sm="3">
        <v-text-field
          :label="$t('fleet.width') + ' *'"
          suffix="cm"
          type="number"
          v-model="properties.vehicle_dimensions.width"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="3">
        <v-text-field
          :label="$t('fleet.height') + ' *'"
          suffix="cm"
          type="number"
          v-model="properties.vehicle_dimensions.height"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="3">
        <v-text-field
          :label="$t('fleet.length') + ' *'"
          suffix="cm"
          type="number"
          v-model="properties.vehicle_dimensions.length"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="3">
        <v-text-field
          :label="$t('fleet.max_weight') + ' *'"
          suffix="kg"
          type="number"
          v-model="properties.vehicle_max_weight"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>

      <v-col sm="12">{{$t('fleet.case')}}</v-col>
      <v-col sm="3">
        <v-text-field
          :label="$t('fleet.width') + ' *'"
          suffix="cm"
          type="number"
          v-model="properties.case_dimensions.width"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="3">
        <v-text-field
          :label="$t('fleet.height') + ' *'"
          suffix="cm"
          type="number"
          v-model="properties.case_dimensions.height"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="3">
        <v-text-field
          :label="$t('fleet.length') + ' *'"
          suffix="cm"
          type="number"
          v-model="properties.case_dimensions.length"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="3">
        <v-text-field
          :label="$t('fleet.max_weight') + ' *'"
          suffix="kg"
          type="number"
          v-model="properties.case_max_weight"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>

      <v-col sm="12">
        <v-checkbox
          color="kazan"
          :label="$t('fleet.roof')"
          v-model="vehicleHasRoof"
          hide-details
          class="mt-0"
        ></v-checkbox>
      </v-col>
      <v-col sm="12" v-if="vehicleHasRoof">
        <v-row>
          <!-- <v-flex sm12>{{$t('fleet.roof')}}</v-flex> -->
          <v-col sm="3">
            <v-text-field
              :label="$t('fleet.width') + ' *'"
              suffix="cm"
              type="number"
              v-model="properties.roof_dimensions.width"
              :rules="[v => !!v && vehicleHasRoof || $t('general.required_field')]"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              :label="$t('fleet.height') + ' *'"
              suffix="cm"
              type="number"
              v-model="properties.roof_dimensions.height"
              :rules="[v => !!v && vehicleHasRoof || $t('general.required_field')]"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              :label="$t('fleet.length') + ' *'"
              suffix="cm"
              type="number"
              v-model="properties.roof_dimensions.length"
              :rules="[v => !!v && vehicleHasRoof || $t('general.required_field')]"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              :label="$t('fleet.max_weight') + ' *'"
              suffix="kg"
              type="number"
              v-model="properties.roof_max_weight"
              :rules="[v => !!v && vehicleHasRoof || $t('general.required_field')]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col sm="12">
        <v-checkbox
          color="kazan"
          :label="$t('fleet.trailer')"
          v-model="vehicleHasTrailer"
          hide-details
          class="mt-0"
        ></v-checkbox>
      </v-col>
      <v-col sm="12" v-if="vehicleHasTrailer">
        <v-row  >
          <!-- <v-flex sm12>{{$t('fleet.trailer')}}</v-flex> -->
          <v-col sm="3">
            <v-text-field
              :label="$t('fleet.width') + ' *'"
              suffix="cm"
              type="number"
              v-model="properties.trailer_dimensions.width"
              :rules="[v => !!v && vehicleHasTrailer || $t('general.required_field')]"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              :label="$t('fleet.height') + ' *'"
              suffix="cm"
              type="number"
              v-model="properties.trailer_dimensions.height"
              :rules="[v => !!v && vehicleHasTrailer || $t('general.required_field')]"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              :label="$t('fleet.length') + ' *'"
              suffix="cm"
              type="number"
              v-model="properties.trailer_dimensions.length"
              :rules="[v => !!v && vehicleHasTrailer || $t('general.required_field')]"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              :label="$t('fleet.max_weight') + ' *'"
              suffix="kg"
              type="number"
              v-model="properties.trailer_max_weight"
              :rules="[v => !!v && vehicleHasTrailer || $t('general.required_field')]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'VehicleFormProperties',
  props: ['value'],
  data () {
    return {
      vehicleHasRoof: false,
      vehicleHasTrailer: false,
      properties: JSON.parse(JSON.stringify(this.value))
    }
  },
  watch: {
    properties: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  mounted () {
    const roof = this.properties.roof_dimensions
    const trailer = this.properties.trailer_dimensions
    if (Number(roof.height) !== 0 || Number(roof.length) !== 0 || Number(roof.width) !== 0 || Number(this.properties.roof_max_weight) !== 0) {
      this.vehicleHasRoof = true
    }
    if (Number(trailer.height) !== 0 || Number(trailer.length) !== 0 || Number(trailer.width) !== 0 || Number(this.properties.trailer_max_weight) !== 0) {
      this.vehicleHasTrailer = true
    }
  }
}
</script>
